import { useEffect, useState } from "react"
import Meals, { IMeal } from "../../shared/Meals"
import Table from "../../gui/Table/Table"
import Loading from "../../gui/Loading/Loading"
import EmptyMeals from "./EmptyMeals"
import MealsCache from "../../data/MealsCache"
import { useSnackbar } from "../../gui/Snackbar/SnackbarProvider"
import useViewMeal from "./MealDlg"
import { usePath } from "../../libs/path/PathProvider"

const COLS = ["name"]
const LABELS:Record<string,string> = {
    name:"Name"
}

function MealsTable(props:{meals:IMeal[]}) {
    const {viewMeal,hideMeal} = useViewMeal()
    const {path,setPath} = usePath()

    useEffect(() => {
        const [_,home,mealId] = path.split("/")
        if (mealId) viewMeal(props.meals.find(meal => meal._id==mealId))
        else hideMeal()
    }, [path])

    const rowProp = (row:IMeal) => ({onClick:() => setPath("/meals/"+row._id)})
    return <Table rows={props.meals} tableName="meals" cols={COLS} label={LABELS} rowKey={row => row._id} tr={rowProp}/>
}
export default function MealList(){
    const [meals,setMeals] = useState<IMeal[]|null>(null)
    const {addSnackbar} = useSnackbar()

    const onRefresh = async () => {
        try {
            setMeals(await MealsCache.i.getMeals().then( (meals:Meals) => meals.items))
        }catch(e) {
            addSnackbar(e)
        }
    }

    useEffect(() => {
        onRefresh()
        MealsCache.i.on("update", onRefresh)
        return () => { MealsCache.i.removeListener("update", onRefresh)}
    }, [])
    const list = meals ? (meals.length ? <MealsTable meals={meals}/> : <EmptyMeals/>) : <Loading className="mt-32"/>
    return <div id="meals">{list}</div>
}